export const selectCommonDefaultProps = {
  minLength: 2,
  showIcons: true,
  loadOptions: {},
  longDescription: true,
  isOpen: false,
  readOnly: false
};

export const selectCommonDefaultState = {
  inputValue: '',
  indexOfFocusedOption: -1,
  showLongDescription: false
};

export const minLengthToExecuteSearch = 2;

/**  
 * numberOfLevels determine how many levels 
 * are fetched during asking about hierarchy options.
 */
export const numberOfLevels = 2;

export const showIndexWhenItemCountIsAbove = 120;

export const maxOptionsPerPageLimit = 24;

export enum optionTypes  {
  CATEGORY_OPTION = 'categoryOption',
  OPTION = 'option'
}
